<div class="shopping-page" dir="rtl" [class.phone-search]="phonePanel === 'search'"
  [class.phone-list]="phonePanel === 'list'">
  <header class="hero">
    <div>
      <h1>מה קונים היום?</h1>
    </div>
  </header>

  @if (errorMessage) {
  <p class="message error" role="alert" data-testid="shopping-error">{{ errorMessage }}</p>
  }
  @if (statusMessage) {
  <p class="message status" role="status">{{ statusMessage }}</p>
  }

  <div class="workspace">
    <main class="main-column">
      <section class="card composer-card" aria-labelledby="composer-title">
        <app-product-search
          [selectedCity]="selectedCity"
          [selectedBranchId]="selectedBranchId"
          [cameraAvailable]="cameraAvailable"
          [isBasketClosed]="isBasketClosed"
          [addingProductIds]="addingProductIds"
          [basketNeeds]="basket?.needs ?? []"
          [busyNeedIds]="busyNeedIds"
          (openLocationSettings)="openLocationSettings()"
          (addProduct)="addProduct($event.product, $event.quantity, $event.weightPhotoId)"
          (adjustQuantity)="adjustSearchQuantity($event.product, $event.quantity, $event.weightPhotoId)"
          (errorNotice)="errorMessage = $event"
        />
      </section>
    </main>

    <aside class="list-column">
      <app-basket-view
        [basket]="basket"
        [selectedBranchId]="selectedBranchId"
        [selectedCityLabel]="selectedCityLabel"
        [selectedBranchLabel]="selectedBranchLabel"
        [hasSelectedLocation]="hasSelectedLocation"
        [basketLoading]="basketLoading"
        [isBasketClosed]="isBasketClosed"
        [busyNeedIds]="busyNeedIds"
        [estimatingNeedIds]="estimatingNeedIds"
        [swappingNeedIds]="swappingNeedIds"
        [loadingAlternatives]="loadingAlternatives"
        [alternativesByProduct]="alternativesByProduct"
        [catalogPrices]="catalogPrices"
        [countBumped]="countBumped"
        [basketOriginBranchMismatch]="basketOriginBranchMismatch"
        [basketOriginBranchLabel]="basketOriginBranchLabel"
        [productIdsWithImages]="productIdsWithImages"
        [brokenImageIds]="brokenImageIds"
        [savingBasketName]="savingBasketName"
        [basketNameSaved]="basketNameSaved"
        (quantityChange)="changeQuantity($event.need, $event.quantity)"
        (weightPhoto)="estimateNeedWeight($event.need, $event.frameJpeg)"
        (removeNeed)="removeNeed($event)"
        (swapWithAlternative)="swapNeedWithAlternative($event.need, $event.alt)"
        (saveBasketName)="saveBasketName($event)"
        (reopenBasket)="reopenCurrentBasket()"
        (toggleShare)="toggleBasketGroupShare()"
        (switchBranch)="switchToBasketBranch()"
        (openLocation)="openLocationSettings()"
        (openLogin)="openLoginModal()"
        (openImage)="openImagePopup($event)"
        (imageBroken)="markImageBroken($event)"
      />
    </aside>
  </div>

  <app-price-comparison-view
    [comparison]="comparison"
    [busyNeedIds]="busyNeedIds"
    [profileBusy]="profileBusy"
    [compareLoading]="compareLoading"
    (approve)="approveSuggestion($event)"
    (lock)="lockExact($event)"
  />

  <nav class="phone-tabs" aria-label="ניווט קניות" role="tablist">
    <button type="button" class="phone-tab" role="tab" data-testid="phone-tab-search"
      [class.phone-tab--selected]="phonePanel === 'search'" [attr.aria-selected]="phonePanel === 'search'"
      (click)="phonePanel = 'search'">
      <span class="phone-tab-icon">
        <svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true" focusable="false">
          <circle cx="11" cy="11" r="6.5" fill="none" stroke="currentColor" stroke-width="2" />
          <path d="M16 16.5 20.5 21" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
        </svg>
      </span>
      <span>חיפוש</span>
    </button>
    <button type="button" class="phone-tab" role="tab" data-testid="phone-tab-cart"
      [class.phone-tab--selected]="phonePanel === 'list'" [attr.aria-selected]="phonePanel === 'list'"
      (click)="phonePanel = 'list'">
      <span class="phone-tab-icon">
        <svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true" focusable="false">
          <path d="M6 7h15l-1.5 8.5H8L6 7Z" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linejoin="round" />
          <path d="M6 7 5 4H2" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
          <circle cx="9" cy="20" r="1.25" fill="currentColor" />
          <circle cx="18" cy="20" r="1.25" fill="currentColor" />
        </svg>
        @if (totalCartItemsCount > 0) {
        <span class="phone-tab-count" [class.count-bumped]="countBumped" data-testid="phone-cart-count"
          [attr.aria-label]="totalCartItemsCount + ' פריטים בסל'">
          {{ totalCartItemsCount }}
        </span>
        }
      </span>
      <span>סל</span>
    </button>
  </nav>

  <app-location-selector-modal
    [isOpen]="locationSettingsOpen"
    [cities]="cities"
    [selectedCity]="selectedCity"
    [citiesLoading]="citiesLoading"
    [branches]="branches"
    [selectedBranchId]="selectedBranchId"
    [branchesLoading]="branchesLoading"
    (close)="closeLocationSettings()"
    (cityChange)="onCityChange($event)"
    (branchChange)="onBranchChange($event)"
  />

  <app-group-share-modal
    [isOpen]="shareGroupOpen"
    [basket]="basket"
    [selectedCity]="selectedCity"
    [selectedBranchId]="selectedBranchId"
    (close)="closeShareGroup()"
    (basketUpdated)="onBasketShared($event)"
    (statusNotice)="statusMessage = $event"
  />
</div>
